import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import NotificationInbox from './NotificationInbox';
import './NotificationDropdown.css';

export interface NotificationDropdownProps {
  onClose: () => void;
}

export const NotificationDropdown: React.FC<NotificationDropdownProps> = ({ onClose }) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };

    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div ref={dropdownRef} className="notif-dropdown" role="dialog" aria-label="Уведомления">
      <NotificationInbox
        onClose={onClose}
        onNavigate={(url) => navigate(url)}
      />
    </div>
  );
};

export default NotificationDropdown;
